import config from '@/config/user.env';
import request from '@/utils/http';
import { getDictCache, setDictCache } from '@/utils/dictCacheUtils';
import axios from 'axios';

// 附件上传（附件传给后台，后台再传oss）
export const uploadAttachment = params => {
    return request({
        url: '/api-ntp/ntp/lcFile/ntpUploadWithOcr',
        method: 'post',
        data: params,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

// 字典值
export const dict = (popPrefix, params, force = false) => {
    const type = Object.prototype.toString.call(params);
    let dictCodes = null;
    if (type === '[object String]') {
        dictCodes = params;
    } else {
        dictCodes = params.dictCodes;
    }
    const data = getDictCache(dictCodes);
    if (!force && data.passKeys === '') {
        return new Promise(resolve => {
            resolve({
                code: '0',
                data: data.result
            });
        });
    } else {
        return request({
            url: popPrefix,
            method: 'get',
            params: {
                // 不区分租户
                // tenantCode: params.tenantCode
                dictCodes: force ? dictCodes : data.passKeys
            }
        }).then(res => {
            setDictCache(res.data);
            res.data = { ...data.result, ...res.data };
            return res;
        });
    }
};

export const dictWithUrl = params => {
    return dict(config.dcDictPath, params);
};

// 远程搜索
export const longRange = (longPrefix, params) => {
    return request({
        url: longPrefix,
        method: 'post',
        data: params
    }).then(res => res);
};

// ----------------------------------------------文件上传接口
const origin = window.location.origin;

export const upload = (data, params, onUploadProgress = () => {}) => {
    return request({
        url: `${origin}/oss-upload/oss/object/upload/${params.appid}/${params.bucket}/${params.object}`,
        method: 'put',
        data: data,
        onUploadProgress,
        headers: {
            certification: params.certification,
            'x-amz-date': new Date().toGMTString()
        }
    });
};

export const getUploadId = params => {
    return request({
        url: `${origin}/oss-api/appmanager/multiupload/init`,
        method: 'post',
        data: params,
        headers: {
            certification: params.certification,
            'x-amz-date': new Date().toGMTString(),
            'x-amz-acl': 'private'
        }
    });
};

export const multiUpload = (data, params) => {
    return request({
        url: `${origin}/oss-upload/oss/object/uploadpart/${params.appid}/${params.bucket}/${params.object}?partNumber=${params.index}&uploadId=${params.uploadid}`,
        method: 'put',
        data: data,
        headers: {
            certification: params.certification,
            'x-amz-date': new Date().toGMTString(),
            'x-amz-acl': 'private'
        }
    });
};

export const completeMultiUpload = params => {
    return request({
        url: `${origin}/oss-api/appmanager/multiupload/complete`,
        method: 'POST',
        data: params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};

export const getCertBySDK = (params, cancelToken = () => {}) => {
    return request({
        url: '/api-file/public/oos/certification',
        method: 'GET',
        params: params,
        cancelToken: new axios.CancelToken(cancelToken)
    });
};

export const saveUserUpload = params => {
    return request({
        url: '/api-file/public/mdmFileInfo',
        method: 'POST',
        data: params,
        /* 转换成formData */
        transformRequest: [
            function (data) {
                let ret = '';
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {
                        ret += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
                    }
                }
                return ret;
            }
        ]
    });
};
